import * as React from 'react';
import { Alert, Typography } from '@mui/material';
import { useGetIdentity } from 'react-admin';

/**
 * Persistent banner for the 7-day pre-expiry server message (in addition to the daily toast).
 */
export function LicensePreExpiryBanner() {
    const { identity } = useGetIdentity();
    const locked = (identity as { companyLicenseLocked?: boolean } | undefined)?.companyLicenseLocked === true;
    const msg = (identity as { companyLicenseWarningMessage?: string } | undefined)?.companyLicenseWarningMessage?.trim();
    const inGrace = (identity as { licenseInGracePeriod?: boolean } | undefined)?.licenseInGracePeriod === true;

    if (locked || inGrace || !msg) return null;

    return (
        <Alert severity="warning" sx={{ borderRadius: 0, py: 0.5 }}>
            <Typography variant="body2" component="span">
                {msg}
            </Typography>
        </Alert>
    );
}
